import Helpers from "./Helpers";

class PressAgenda {
  constructor() {
    this.elements = document.querySelectorAll('.press-agenda__item__go .cross');

    if (this.elements.length) {
      this.init();
    }
  }

  init() {
    this.elements.forEach(element => {
      element.addEventListener('click', event => {
        const el = event.currentTarget;
        const item = el.closest('.press-agenda__item');
        const info = item.querySelector('.press-agenda__item__hidden-info');

        Helpers.slideToggle(info).then(() => {
          el.classList.toggle('open');
        });
      });
    });
  }
}

export default PressAgenda;
